import { instance } from './index';

//계정 아이디와 비밀번호를 이용하여 로그인 한 뒤. 접속용 토큰을 획득한다.
function loginUser(userData) {
  return instance.post('api/authorizes/login', userData);
}

//현재 접속된 계정을 로그아웃 하여 토큰을 제거한다.
function logoutUser() {
  return instance.post('api/authorizes/logout');
}

//전체 계정의 인증코드를 재생성, 자기자신은 재생성하지 않음.

function authCodereset() {
  return instance.post('api/authorizes/codereset');
}

export { loginUser, logoutUser, authCodereset };
